/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Heading } from '@/pages/DocsPage/DocsLayout/PanelMenuDoc';
import React, { useRef } from 'react';
import { classNames } from 'primereact/utils';

interface Props {
  node: Heading;
  docWrapperId: string;
  isActive?: boolean;
}

export const RecapLink: React.FC<Props> = ({ node, docWrapperId, isActive }) => {
  const anchorLinkRef = useRef<HTMLAnchorElement>(null);

  const handleClick = () => {
    const docRef = document.body.querySelector(`#${docWrapperId}`);

    if (docRef) {
      const anchorLink: HTMLAnchorElement | null = docRef.querySelector(`a[href='${node.ref}'][class="anchor-link"]`);
      if (anchorLink) {
        docRef.scrollTo({
          top: anchorLink.offsetTop,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <div data-pc-section="content">
      <a ref={anchorLinkRef} onClick={handleClick} href={node.ref} tabIndex={-1} data-pc-section="action">
        <span className={classNames({ 'text-primary': isActive })} data-pc-section="label">
          {node.title}
        </span>
      </a>
    </div>
  );
};
